import {ListGroup, Offcanvas} from 'react-bootstrap'

export const AsideMenuPolicies: React.FC<{
  isOpen: boolean
  onClose: () => void
  tabFilters: string
  filtersPolicies: {id: string; name: string; icon: string}[]
  canViewCarrierImportHistory: boolean
  onSelectPolicies: () => void
  onSelectPolicyType: (id: string) => void
  onSelectImportant: () => void
  onSelectReminders: () => void
  onSelectArchived: () => void
  onSelectImportHistory: () => void
}> = ({
  isOpen,
  onClose,
  tabFilters,
  filtersPolicies,
  canViewCarrierImportHistory,
  onSelectPolicies,
  onSelectPolicyType,
  onSelectImportant,
  onSelectReminders,
  onSelectArchived,
  onSelectImportHistory,
}) => {
  return (
    <Offcanvas show={isOpen} onHide={onClose}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title></Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div
          style={{
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            backgroundColor: '#fff',
            marginBottom: '20px',
            padding: '8px 10px',
          }}
        >
          <div
            style={{
              borderBottom: '2px solid rgba(93, 120, 255, 0.2)',
              paddingBottom: '7px',
            }}
          >
            <h5 style={{fontSize: '13px'}}>Menu</h5>
          </div>

          <div>
            <ListGroup className='mt-5' variant='flush'>
              <ListGroup.Item
                action
                variant={tabFilters === 'Policies' ? 'primary' : 'light'}
                className='my-2 py-4'
                onClick={() => {
                  onSelectPolicies()
                  onClose()
                }}
              >
                <i className='bi bi-person-fill fs-3' style={{color: 'inherit'}} /> Policies
              </ListGroup.Item>
              {filtersPolicies.map((lis) => (
                <ListGroup.Item
                  key={lis.id}
                  action
                  variant={tabFilters === lis.id ? 'primary' : 'light'}
                  className='my-1 py-4 d-flex align-items-center justify-content-between'
                  onClick={() => {
                    onSelectPolicyType(lis.id)
                    onClose()
                  }}
                >
                  <span className='d-flex align-items-center justify-content-between gap-1'>
                    {lis.icon && (
                      <i className={`bi bi-${lis.icon} fs-3`} style={{color: 'inherit'}} />
                    )}{' '}
                    {lis.name}
                  </span>
                </ListGroup.Item>
              ))}
              <ListGroup.Item
                action
                variant={tabFilters === 'Important' ? 'primary' : 'light'}
                className='my-2 py-4'
                onClick={() => {
                  onSelectImportant()
                  onClose()
                }}
              >
                <i className='bi bi-star-fill fs-3' style={{color: 'inherit'}} /> Important
              </ListGroup.Item>
              <ListGroup.Item
                action
                variant={tabFilters === 'Reminders' ? 'primary' : 'light'}
                className='my-2 py-4'
                onClick={() => {
                  onSelectReminders()
                  onClose()
                }}
              >
                <i className='bi bi-clock fs-3' style={{color: 'inherit'}} /> Reminders
              </ListGroup.Item>
              <ListGroup.Item
                action
                variant={tabFilters === 'Archived' ? 'primary' : 'light'}
                className='my-2 py-4'
                onClick={() => {
                  onSelectArchived()
                  onClose()
                }}
              >
                <i className='bi bi-folder-fill fs-3' style={{color: 'inherit'}} /> Archived
              </ListGroup.Item>
              {canViewCarrierImportHistory && (
                <ListGroup.Item
                  action
                  variant={tabFilters === 'ImportHistory' ? 'primary' : 'light'}
                  className='my-2 py-4'
                  onClick={() => {
                    onSelectImportHistory()
                    onClose()
                  }}
                >
                  <i className='bi bi-cloud-upload fs-3' style={{color: 'inherit'}} /> Carrier Import History
                </ListGroup.Item>
              )}
            </ListGroup>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  )
}
